import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DashboardLayout, MainContent } from "./StyledComp";
import Sidebar from "./SideBar";
import TopBar from "./TopBar";
import BPACommonSearchApp from "@egovernments/digit-ui-module-obps/src/pages/citizen/MyApplication/BPACommonSearch";
import UserProfile from "../../pages/citizen/Home/UserProfile";
import FileStrip from "./FileInfo";

function SideTopBarLayout({ t, stateInfo, userDetails, CITIZEN, cityDetails, children,formData }) {
  const location = useLocation();
  const isObpsRoute = location.pathname.includes("obps");
  const isProfileRoute = location.pathname.includes("profile");
  const isProfileAccount = location.pathname.includes("account");
  const stateId = Digit.ULBService.getStateId();
  const [applicationDetail, setApplicationDetail] = useState(null);
  const [ltpDetail, setLtpDetail] = useState(null);
  const [mapDetails, setMapDetails] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setUserData] = useState(null)


  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  // Polling or a single fetch on mount
  useEffect(() => {
     const fetchAndSetUserDetails = async () => {
      const { info: userInfo } = Digit.UserService.getUser();
      const uuid = userInfo?.uuid;

      if (uuid) {
        const usersResponse = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
        const userDetail = usersResponse?.user?.[0];
        setUserData(userDetail)
        const ltpDetail = {
          user: userDetail,
          // Add other required fields for FileStrip
        };

        Digit.SessionStorage.set("USER_DETAIL", userDetail);
        Digit.SessionStorage.set("LTP_DETAIL", ltpDetail);
        return ltpDetail;
      }
      return null;
    };

    const interval = setInterval(async () => {
      const appDetailFromSession = Digit.SessionStorage.get("FASTPAS_ID");
      let userDetailFromSession = Digit.SessionStorage.get("USER_DETAIL");
      const mapDetailsFromSession = Digit.SessionStorage.get("FORM_MAP_SUBMISSION");

      // If user details aren't in session, fetch them
      if (!userDetailFromSession) {
        userDetailFromSession = await fetchAndSetUserDetails();
      }

      if (appDetailFromSession) setApplicationDetail(appDetailFromSession);
      if (userDetailFromSession) setLtpDetail(userDetailFromSession);
      if (mapDetailsFromSession) setMapDetails(mapDetailsFromSession);

      // Clear polling if all required data is available
      if (appDetailFromSession && userDetailFromSession && mapDetailsFromSession) {
        clearInterval(interval);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <DashboardLayout isObpsRoute={isObpsRoute}>
      <Sidebar userDetails={userData}  collapsed={collapsed} toggleSidebar={toggleSidebar} setCollapsed={setCollapsed}/>
      <MainContent collapsed={collapsed} >
      <TopBar userDetails={userDetails} collapsed={collapsed} applicationDetail={applicationDetail}  toggleSidebar={toggleSidebar} /> 
       {/* <TopBarNewDesign userDetails={userDetails} applicationDetail={applicationDetail} toggleSidebar={toggleSidebar} /> */}
        <FileStrip ltpDetail={ltpDetail} mapDetailsFromSession={mapDetails} />
        {isProfileRoute && <BPACommonSearchApp />}
        {isProfileAccount && <UserProfile />}
        <div style={{ flex: 1, overflow: "auto" }}>{children}</div>
      </MainContent>
    </DashboardLayout>
  );
}

export default SideTopBarLayout;
